import React, { useState, useEffect, useRef } from 'react';
import { Dropdown, Menu, Input, message } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { ReactComponent as GlobalSearchIcon } from '../../../assets/images/svg/GlobalSearchIcon.svg';
import { ReactComponent as GlobalSearchResetIcon } from '../../../assets/images/svg/GlobalSearchResetIcon.svg';
import './tag.less';
import {
  GLOBAL_SEARCH_DROPDOWN_ITEMS,
  GLOBAL_SEARCH_NULL_MESSAGE,
} from '../../constants/commonConstants';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import {
  resetInPatientFilters,
  searchInPatientList,
  setTpaGlobalSearch,
  setTpaGlobalSearchValue,
  updateDropdownSearchFilter,
} from '../../../store/actions/inPatientAction';
import loadingAnimation from '../../../assets/images/lottie-json/lottie_globalSearchLoader.json';
import Lottie from 'react-lottie';

const GlobalSearch: React.FC<{
  handleSearchClick: (key: string, text: string) => void;
}> = ({ handleSearchClick }: any): any => {
  const { tpaGlobalSearch, tpaGlobalSearchClicked, tpaGlobalSearchValue, selectedDateDropdown } =
    useSelector(
      (state: RootState): any => state?.selectedInPatientDetail || {},
    );
  const [selectedKey, setSelectedKey] = useState<string>(
    tpaGlobalSearch?.key || 'patientName',
  );
  const [searchText, setSearchText] = useState<string>(
    tpaGlobalSearchValue || '',
  );
  const [showReset, setShowReset] = useState<boolean>(false);
  const inputRef = useRef<Input | null>(null);

  const [error, setError] = useState<boolean>(false);
  const dispatch = useDispatch();
  const globalSearchLoader = {
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  useEffect((): any => {
    setSearchText(tpaGlobalSearchValue || '');
  }, [tpaGlobalSearchValue]);

  const handleMenuClick = (e: any): void => {
    setSelectedKey(e?.key as string);
    setSearchText('');
  };

  const selectedLabel =
    GLOBAL_SEARCH_DROPDOWN_ITEMS.find(
      (item: any): boolean => item?.key === selectedKey,
    )?.label || 'patientName';

  const handleSearch = (): void => {
    if (!searchText?.trim()) {
      setError(true);
      message.error(GLOBAL_SEARCH_NULL_MESSAGE);
      return;
    }
    setError(false);
    handleSearchClick(selectedKey, searchText);
  };
  const clearSearch = (): void => {
    const dateFilter = selectedDateDropdown;
    setShowReset(false);
    setSearchText('');
    if (tpaGlobalSearchValue) {
      dispatch(setTpaGlobalSearch({ ...tpaGlobalSearch, value: '' }));
      dispatch(resetInPatientFilters());
      dispatch(setTpaGlobalSearchValue(''));
      dispatch(updateDropdownSearchFilter({dateFilter}));
      dispatch(searchInPatientList());
      setError(false);
    }
    setTimeout((): void => {
      inputRef.current?.focus();
    });
  };

  const menu = (
    <Menu className="custom-dropdown" onClick={handleMenuClick}>
      {GLOBAL_SEARCH_DROPDOWN_ITEMS.map((item: any): any => (
        <Menu.Item className="custom-dropdown-menu-item" key={item?.key}>
          {item?.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div className="globalSearchContainerGrid">
      <div className="globalSearchNewTag">New</div>
      <div className="globalSearchContainer">
        <Dropdown
          overlay={<div className="his-select">{menu}</div>}
          trigger={['click']}
          getPopupContainer={(triggerNode: HTMLElement | null): HTMLElement =>
            triggerNode?.parentElement ?? document.body
          }
        >
          <div className="globalSearchDropdown">
            <span>{selectedLabel}</span>
            <DownOutlined />
          </div>
        </Dropdown>
        <Input
          ref={inputRef}
          placeholder={`Search using ${selectedLabel}`}
          value={searchText}
          disabled={tpaGlobalSearchClicked}
          onChange={(e: any): any => {
            setSearchText(e?.target?.value);
            setError(false);
            setTimeout((): void => {
              inputRef.current?.focus();
            });
            setShowReset(e?.target?.value.length > 0);
          }}
          onPressEnter={handleSearch}
          className={`globalSearchInput ${error ? 'input-error' : ''}`}
          suffix={
            ((showReset || tpaGlobalSearchValue) && !tpaGlobalSearchClicked) && (
              <GlobalSearchResetIcon
                onClick={clearSearch}
                className="globalFilterResetIcon"
              />
            )
          }
        />
        {tpaGlobalSearchClicked ? (
          <span className="globalSearchLoader">
            <Lottie options={globalSearchLoader} />
          </span>
        ) : (
          <GlobalSearchIcon
            onClick={handleSearch}
            className="globalSearchIcon"
          />
        )}
      </div>
    </div>
  );
};

export default GlobalSearch;
